export default __webpack_public_path__ + "static/media/pixellab--web-design--02a--1200x900.102207b6.jpg";